
// file Route & run app integration

import routing from './integrationPanel.route';
import run from './integrationPanel.run';

// tablas de integracion y datos cargados
import tablesint from './tablesint';
import tables from './tables';

// controllers & services module Users
import executeDataController from './integration_action/execute/executeDataController';
import integrationServices from './integrationServices';

export default angular.module('app.executionPanel', [integrationServices,tablesint,tables])
  .config(routing)
  .controller('executeDataController', executeDataController)
  .run(run)
  .constant("ExecutionIntegrationPanel", [
     {

        "title": "DATA_INTEGRATION",
        "icon":"fal fa-sync",
        "subMenu":[
            {
            'title' : 'INITIATE_DATA_INTEGRATION',
            'url':   'app.integracion'
            },
            {
            // "title": "MENU.INTEGRATION_TABLES",
            "title": "Tablas de integración",
            "superMenu":[
                {
                  'title' : 'CAMPUS',
                  'url': 'app.tableint_campus'
                },
                {
                  'title' : 'MENU_ACADEMIC_PERIOD',
                  'url': 'app.tableint_periodo'
                },
                {
                  'title' : 'MENU_CLASS_TIME',
                  'url': 'app.tableint_horaClase'
                },
                {
                  'title' : 'MENU_INFRASTRUCTURE',
                  'url': 'app.tableint_infraestructura'
                },
                {
                  'title' : 'MENU_INFRASTRUCTURE_TYPE_USE',
                  'url': 'app.tableint_infraestructuratipouso'
                },
                {
                  'title' : 'MENU_STUDY_PLAN_SUBJECT',
                  'url': 'app.tableint_planestudioasignatura'
                },
                {
                  'title' : 'MENU_STUDY_PLAN_SHIFT',
                  'url': 'app.tableint_planestudioturno'
                },
                {
                  'title' : 'MENU_ACTIVITY_SUBJECT_DETAIL',
                  'url': 'app.tableint_actividadasignaturadetalle'
                },
                {
                  'title' : 'MENU_ACTIVITY_SUBJECT_TYPE_USE',
                  'url': 'app.tableint_actividadasignaturatipouso'
                },
                {
                  'title' : 'MENU_VALUE_TIME_SUBJECT',
                  'url': 'app.tableint_valorhoraasignatura'
                },
                {
                  'title' : 'MENU_CAREER_TARIFF',
                  'url': 'app.tableint_arancelcarrera'
                },
                {
                  'title' : 'MENU_TEACHER',
                  'url': 'app.tableint_docente'
                },
                {
                  'title' : 'MENU_TEACHER_ACTIVITY_SUBJECT',
                  'url': 'app.tableint_docenteasignaturaactividadsede'
                },
                {
                  'title' : 'MENU_TEACHER_VALUE_TIME_EVALUATION',
                  'url': 'app.tableint_docentevalorhoraevaluacion'
                },
                {
                  'title' : 'MENU_CLASS_NOTE',
                  'url': 'app.tableint_notaclase'
                }
              ]
            },
            {
            // "title": "MENU_LOADED_DATA",
            "title": "Datos Cargados",
            "superMenu":[
                {
                  'title' : 'INSTITUTION',
                  'url': 'app.table_institucion({type:"institucion"})',
                },
                {
                  'title' : 'CAMPUS',
                  'url': 'app.table_campus({type:"campus"})',
                },
                {
                  'title' : 'PERIOD',
                  'url': 'app.table_periodo({type:"periodo"})',
                },
                {
                  'title' : 'SHIFT',
                  'url': 'app.table_jornada({type:"jornada"})',
                },
                {
                  'title' : 'MENU_MODULES_DAY',
                  'url': 'app.table_modulos_jornada({type:"dm"})',
                },
                {
                  'title' : 'MENU_PLANS_CAMPUS',
                  'url': 'app.table_planes_campus({type:"cpjc"})',
                },
                {
                  'title' : 'CAREER',
                  'url': 'app.table_carrera({type:"carrera"})',
                },
                {
                  'title' : 'MENU_STUDY_PLAN',
                  'url' : 'app.table_plan_estudio({type:"plan"})',
                },
                {
                  'title' : 'MENU_SUBJECTS_BY_PLAN',
                  'url' : 'app.table_materia_plan({type:"pm"})',
                },
                {
                  'title' : 'APARTAMENT',
                  'url' : 'app.table_departamento({type:"unidad_academica"})',
                },
                {
                  'title' : 'MENU_SUBJECTS_BY_DEPARTAMENT',
                  'url' : 'app.table_materia_departamento({type:"uam"})',
                },
                {
                  'title' : 'MENU_ACTIVITY',
                  'url': 'app.table_actividad({type:"actividad"})',
                },
                {
                  'title' : 'MENU_CLASS_NOTE',
                  'url' : 'app.table_nota_clase({type:"nota"})',
                }
              ]
            }
        ]


    }])
  .name;





// WEBPACK FOOTER //
// ./src/app/integration-front/index.js